var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDog201(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_201"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_201",
    "data-name": 201,
    className: "cls-2",
    d: "M32.6,7.08C41.05-.12,56-.4,64.68,6.68,75,15.1,72.77,31,71,43.5c-3.66,26-19.12,56.53-30.4,54.71C28.21,96.21,26.36,56,25.7,41.8,24.47,15,30.26,9.08,32.6,7.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog201);
export default __webpack_public_path__ + "static/media/dog_201.94da046b810691478db94ad03db345e3.svg";
export { ForwardRef as ReactComponent };